import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { ComponentsRoutingModule } from './components-routing.module'
import { ShareModule } from '../share/share.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { 
  MatButtonModule, 
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatFormFieldModule,
  MatDialogModule } from '@angular/material';
import { AppRoutingModule } from '../app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { GlobalServiceService } from '../services/global-service.service';
import { NotificacionesComponent } from './navbar/notificaciones/notificaciones.component';
import { ChangePassComponent, PasswordValidation } from './navbar/change-pass/change-pass.component'
@NgModule({
  imports: [
    CommonModule,
    ShareModule,
    ComponentsRoutingModule,
    MatButtonModule, 
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NgbModule.forRoot()
  ],
  declarations: [
  	NavbarComponent,
  	SidebarComponent,
  	FooterComponent,
  	NotificacionesComponent,
  	ChangePassComponent
  ],
  providers:[
  	GlobalServiceService,
    PasswordValidation
  ],
  entryComponents:[
    ChangePassComponent
  ],
  exports:[
  	NavbarComponent,
  	SidebarComponent,
  	FooterComponent
  ]
})
export class ComponentsModule { }
